import {
    ACTION_WELCOME,
    SET_WELCOME,
} from "@/views/home/store/types/types.js";
import { HomeService } from "../../../services";

const actions = {

    [ACTION_WELCOME]: ({ state, commit }) => {
        return new Promise((resolve, reject) => {
            state.loading = true;

                const idGroup = sessionStorage.getItem("idGroup");
                const idEmpresa = sessionStorage.getItem("idEmpresa");
                const idUsuario = sessionStorage.getItem("idUsuario");

                HomeService.getHome( idGroup, idEmpresa, idUsuario )
                .then(resp => {
                    const welcome = resp.data.payload;
                    commit(SET_WELCOME, welcome);
                    const roleId = resp.data.payload.role.roleId;
                    sessionStorage.setItem('roleId', roleId);
                    resolve(resp.data.payload)
                })
                .catch(err => {
                    reject(err)
                })
                .finally(() => state.loading = false);
        })
    },
}

export default actions;